import type { Sale, SalePayment } from '../../lib/api.js';

export const AWAITING = new Set<SalePayment['status']>(['PENDING', 'AUTHORIZED']);

/// O que a venda já recebeu, o que aguarda confirmação e o que ainda falta (ADR 0053).
export function paymentTotals(sale: Sale) {
  const awaitingCents = sale.payments
    .filter((payment) => AWAITING.has(payment.status))
    .reduce((sum, payment) => sum + payment.amountCents, 0);
  return {
    confirmedCents: sale.confirmedPaymentTotalCents,
    awaitingCents,
    openCents: sale.outstandingTotalCents,
    /// O que ainda cabe num recebimento novo: o aguardando já está combinado.
    registrableCents: Math.max(0, sale.outstandingTotalCents - awaitingCents),
  };
}

export type PaymentState = 'PAID' | 'PARTIAL' | 'AWAITING' | 'NONE' | 'CANCELED';

/// A situação do pagamento vem do que já entrou de fato: aguardando não conta como pago, e o
/// pagamento antecipado aparece como "Parcialmente pago" sem precisar da palavra sinal (ADR 0059).
export function paymentState(sale: Sale): PaymentState {
  if (sale.status === 'CANCELED') return 'CANCELED';
  const totals = paymentTotals(sale);
  if (totals.openCents === 0) return 'PAID';
  if (totals.confirmedCents > 0) return 'PARTIAL';
  if (totals.awaitingCents > 0) return 'AWAITING';
  return 'NONE';
}

export const PAYMENT_STATE = {
  PAID: { label: 'Pago', tone: 'positive' },
  PARTIAL: { label: 'Parcialmente pago', tone: 'warning' },
  AWAITING: { label: 'Aguardando confirmação', tone: 'progress' },
  NONE: { label: 'Sem pagamento', tone: 'danger' },
  CANCELED: { label: 'Cancelada', tone: 'neutral' },
} as const;
